import React from 'react';
import { Tabs } from 'antd';

import DashboardOrder from './DashboardOrder';
import DashboardReceived from './DashboardReceived';
import DashboardTransfer from './DashboardTransfer';


function ReportPanel({ transactionReportQuery }) {
    return (
        <Tabs
            type='card'
            defaultActiveKey="orders"
            items={[
                {
                    key: 'orders',
                    label: 'รายการขายสินค้า',
                    children: <DashboardOrder
                        orders={transactionReportQuery.data.order_items}
                        quantity={transactionReportQuery.data.order_quantity}
                        revenue={transactionReportQuery.data.order_total_price} />,
                },
                {
                    key: 'received',
                    label: 'รายการรับสินค้า',
                    children: <DashboardReceived
                        receivedItems={transactionReportQuery.data.received_items}
                        quantity={transactionReportQuery.data.received_quantity}
                        price={transactionReportQuery.data.received_price}
                    />
                },
                {
                    key: 'transfered',
                    label: 'รายการโอนสินค้า',
                    children: <DashboardTransfer
                        transferedItems={transactionReportQuery.data.transfer_items}
                        quantity={transactionReportQuery.data.transfer_quantity}
                        price={transactionReportQuery.data.transfer_price}
                    />,
                },
            ]} />

    )
}

export default ReportPanel